import React, { useEffect, useState } from "react";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import { Fade } from "react-awesome-reveal";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { client } from "../context/client";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";

function slugify(text) {
  return text
    .toString()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-zA-Z0-9α-ωΑ-Ω ]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
}

export default function News() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const itemsPerPage = 4;

  useEffect(() => {
    const getAllEntries = async () => {
      try {
        await client
          .getEntries({ content_type: "news", order: "-fields.date" })
          .then((entries) => {
            setNews(entries.items);
          });
      } catch (error) {
        console.log(`Error fetching news ${error}`);
      }
    };
    getAllEntries();
  }, []);

  const handleReadMore = (item) => {
    const slug = slugify(item.fields.title);
    navigate(`/news/${slug}`);
  };

  const pageCount = Math.ceil(news.length / itemsPerPage);
  const paginatedNews = news.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Layout>
      <Navbar darkBg />
      <section
        id="home"
        style={{
          minHeight: "70vh",
          paddingTop: "150px",
          paddingBottom: "100px",
        }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-12 col-lg-12">
              <Fade bottom delay={500}>
                <h2 id="headtitle" style={{ color: "#313e5b" }}>
                  News
                </h2>
              </Fade>
            </div>
          </div>

          <div className="row mt-4">
            <Grid container spacing={3}>
              {paginatedNews.map((item) => {
                const { title, description, image, date } = item.fields;
                const imageUrl = image?.fields?.file?.url ? image.fields.file.url : "";

                return (
                  <Grid item xs={12} sm={6} md={3} key={item.sys.id}>
                    <Card
                      sx={{
                        maxWidth: 345,
                        minHeight: 420,
                        borderRadius: 4,
                        boxShadow: 3,
                        display: "flex",
                        flexDirection: "column",
                        transition: "transform 0.2s, box-shadow 0.2s",
                        "&:hover": {
                          transform: "scale(1.03)",
                          boxShadow: 8,
                        },
                        background: "#fff",
                        position: "relative",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        {imageUrl && (
                          <CardMedia
                            sx={{ height: 180, borderTopLeftRadius: 16, borderTopRightRadius: 16 }}
                            image={imageUrl}
                            title={title}
                            style={{ backgroundSize: "cover", backgroundColor: "white" }}
                          />
                        )}

                        {date && (
                          <div
                            style={{
                              position: "absolute",
                              top: 12,
                              right: 12,
                              background: "rgba(237, 237, 237, 0.72)",
                              color: "#313e5b",
                              padding: "4px 12px",
                              borderRadius: 12,
                              fontSize: 13,
                              fontWeight: 500,
                              letterSpacing: 0.5,
                              boxShadow: "0 2px 8px rgba(22,106,163,0.15)",
                            }}
                          >
                            {new Date(date).toLocaleDateString()}
                          </div>
                        )}
                      </div>

                      <CardContent
                        style={{
                          flexGrow: 0,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          paddingBottom: 0,
                        }}
                      >
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          style={{
                            fontWeight: 700,
                            color: "#166aa3",
                            minHeight: 56,
                            fontSize: "1.1rem",
                          }}
                        >
                          {title}
                        </Typography>

                        <div
                          style={{
                            position: "relative",
                            minHeight: 60,
                            maxHeight: 60,
                            overflow: "hidden",
                            marginBottom: 12,
                          }}
                        >
                          <Typography variant="body2" color="text.secondary" style={{ lineHeight: 1.5 }}>
                            {description && description.length > 120
                              ? `${description
                                  .substring(0, 120)
                                  .replace(/\*\*/g, "")
                                  .replace(/\*/g, "")
                                  .replace(/__/g, "")
                                  .replace(/_/g, "")}...`
                              : description
                              ? description
                                  .replace(/\*\*/g, "")
                                  .replace(/\*/g, "")
                                  .replace(/__/g, "")
                                  .replace(/_/g, "")
                              : ""}
                          </Typography>

                          <div
                            style={{
                              position: "absolute",
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              height: 18,
                              background: "linear-gradient(180deg, rgba(255,255,255,0) 0%, #fff 100%)",
                            }}
                          />
                        </div>
                      </CardContent>

                      <div style={{ padding: "0 16px 16px 16px", marginTop: "auto" }}>
                        <Button
                          fullWidth
                          variant="contained"
                          style={{
                            borderRadius: 8,
                            fontWeight: 600,
                            letterSpacing: 0.5,
                            boxShadow: "0 2px 8px rgba(22,106,163,0.10)",
                            backgroundColor: "#313e5b",
                            color: "#fff",
                            transition: "background 0.2s",
                          }}
                          sx={{
                            "&:hover": {
                              backgroundColor: "#222a3b",
                            },
                          }}
                          onClick={() => handleReadMore(item)}
                        >
                          Read More
                        </Button>
                      </div>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </div>

          <div style={{ display: "flex", justifyContent: "center", marginTop: 32 }}>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handlePageChange}
              sx={{
                "& .Mui-selected": {
                  backgroundColor: "#313e5b !important",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root": {
                  fontWeight: 600,
                },
              }}
            />
          </div>
        </div>
      </section>
      <Footer />
    </Layout>
  );
}
